import { CoralHandler, CoralInterceptor, CoralRequest, CoralResponse } from '@amzn/ihm-js-coral-client';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnvironmentDetail } from '@src/utils';
import { CountMetric, LatencyMetric } from '@src/metrics';

export class ServiceCallMetricsInterceptor implements CoralInterceptor {
    public intercept(request: CoralRequest, next: CoralHandler): Observable<CoralResponse<any>> {
        const storeId = EnvironmentDetail.getStoreId();
        const latencyMetric = new LatencyMetric(storeId, 'latency', request.serviceName, request.operation);
        const failureCountMetric = new CountMetric(storeId, 'failures', request.serviceName, request.operation);
        const faultCountMetric = new CountMetric(storeId, 'Fault', request.serviceName, request.operation);

        latencyMetric.start();

        return next.handle(request).pipe(
            tap((response: CoralResponse<any>) => {
                if (response.ok) {
                    failureCountMetric.count(0);
                    faultCountMetric.count(0);
                } else {
                    failureCountMetric.count(1);
                    if (response.status > 400) {
                        faultCountMetric.count(1);
                    }
                }

                latencyMetric.stop();
            }),
        );
    }
}
